import ModuleSetupPage from '../../components/ModuleSetupPage';
import StipendSetupPage from './StipendSetupPage';

export default function SalesSetupPage() {
  return (
    <ModuleSetupPage
      moduleKey="sales"
      moduleLabel="Sales"
      configComponent={<StipendSetupPage />}
    />
  );
}
